<template>
<div class="mb-5">

  <b-row class="clearfix mb-5" v-if="school.loaded()">
    <b-col>
      <h5>Kollegium</h5>
      <users :school=school :users=users></users>
    </b-col>
  </b-row>

  <b-row class="mb-5">
    <b-col>
      <h5>Koordinator*in</h5>

      <div  v-if="showCoordinatorTransfer()">
        <p>
          Sie sind derzeit Koodinator*in und können hier die Rolle an andere Kolleg*innen übertragen.
          <strong>ACHTUNG!</strong> Dies kann nur durch den/die neue Koodinator*in rückgängig gemacht werden!
        </p>
        <coord :school=school :users=users></coord>
      </div>

      <div v-else>
        Die Koordinator*in-Rolle kann nur durch den/die Koordinator*in selbst übertragen werden, wenn mindestens
        ein(e) weitere(r) Kolleg*in im Kollegium registriert ist.
      </div>
    </b-col>
  </b-row>


  <b-row class="clearfix mb-5">
    <b-col>
      <h5>Ausstehende Einladungen</h5>
      <invites v-on:invite="sendInvitation"/>
    </b-col>
  </b-row>


  <b-row class="clearfix">
    <b-col>
      <h5>Kolleg*innen hinzufügen</h5>
      <p>Hier können Sie weitere Kolleg*innen in das Konto der Schule einladen. Geben Sie dazu bitte die Emailadresse an:</p>

      <b-form autocomplete="off">
        <b-form-group label-for="name" label="Name">
          <b-form-input type="text" id="name" v-model="invitation.name" required autocomplete="off"/>
        </b-form-group>
        <b-form-group label-for="email" label="Email-Adresse">
          <b-form-input type="email" id="email" v-model="invitation.email" required autocomplete="off"/>
        </b-form-group>
        <b-form-group class="m-2">
          <b-form-checkbox id="confirm" v-model="invitation.confirmed">
            Ich versichere, dass die von mir eingeladene Person Teil des Kollegiums unserer Schule ist und somit
            die Berechtigung hat, unser HEUREKA!-Schulkonto einsehen zu dürfen.
          </b-form-checkbox>
        </b-form-group>

        <b-button type="button" variant="primary" class="float-right" :disabled="inviteDisabled" v-on:click="newInvitation">
          Einladung senden
        </b-button>
      </b-form>
    </b-col>
  </b-row>

</div>
</template>

<script>
import { School } from '@/models'
import UsersTable from '@/components/schools/UsersTable'
import InvitesTable from '@/components/schools/InvitesTable'
import Coordinator from '@/components/schools/Coordinator'

export default {
  name: 'Team',
  components: {
    coord: Coordinator,
    users: UsersTable,
    invites: InvitesTable
  },
  data () {
    return {
      school: new School(),
      users: [],
      invitation: {
        email: '',
        name: '',
        confirmed: false
      }
    }
  },

  mounted: function () {
    this.loadSchool().then(() => {
      this.loadUsers()
    })
  },

  computed: {
    inviteDisabled: function () {
      const invitation = this.invitation
      return (
        invitation.email &&
        invitation.name &&
        invitation.confirmed
      ) === false
    }
  },

  methods: {
    loadSchool: function () {
      this.school.id = this.$parent.getUser().schoolId
      return this.school.fetch()
    },

    loadUsers: function () {
      this.users = []

      this.axios.get('/schools/me/users').then(rsp => {
        rsp.data.forEach(row => {
          this.users.push({
            id: row.id,
            gender: row.gender,
            firstname: row.firstname,
            lastname: row.lastname,
            email: row.email,
            coordinator: row.id === this.school.coordinatorId
          })
        })
      })
    },

    newInvitation () {
      this.sendInvitation(this.invitation)
    },

    sendInvitation (invitation) {
      this.axios.post('/users/invite', invitation).then(() => {
        this.$eventHub.$emit('info', 'Wir haben eine Einladung an ' + invitation.email + ' gesendet')
        this.resetInvitation()
      }).catch((err) => {
        this.$eventHub.$emit('error', err)
      })
    },

    resetInvitation () {
      this.invitation.name = ''
      this.invitation.email = ''
      this.invitation.confirmed = false
    },

    showCoordinatorTransfer: function () {
      if (this.users.length < 2) {
        return false
      }

      let user = this.$parent.getUser()

      return this.school.isCoordinator(user.id)
    },

    cancel () {
      this.$router.push({name: 'teacher.dashboard'})
    }
  }
}
</script>
<style scoped>
h3 {
  margin-bottom: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/views/users/settings/Team.vue